import i18n from '@/utils/i18n';
import { eachDayOfInterval, lightFormat } from 'date-fns';
import config from '@/config';
import store from '@/store';
import { getToken } from '@/utils/auth';
import momentTimezone from 'moment-timezone'
// eslint-disable-next-line no-undef
const moment = require('moment');
const isChinaTimeZone = new Date().getTimezoneOffset() === -480;
/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * 返回当月第一天
 * @returns {string}
 *  @param format
 * @author: LiuXueChao
 */
export function startOfMonth(format = 'YYYY-MM-DD HH:mm:ss') {
  return moment().startOf('month').format(format);
}

/**
 * @description: 获取当前周
 * @return {*}
 * @Date: 2022-07-19 16:06:19
 * @author: LiuXueChao
 */
export function getCurrentWeek(format = 'YYYY-MM-DD HH:mm:ss') {
  const start = moment().weekday(1).format(format);
  const end = moment().weekday(7).format(format);
  return [start, end];
}
/**
 * 返回当月第最后 一天
 * @returns {string}
 *  @param format
 * @author: LiuXueChao
 */
export function endOfMonth(format = 'YYYY-MM-DD HH:mm:ss') {
  return moment().endOf('month').format(format);
}
/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string}
 */
export function parseTime(time, cFormat, isnotTrans) {
  if (arguments.length === 0 || !time) {
    return null;
  }
  if (/^[0-9]+$/.test(time)) {
    time = window.formateTimesStamp(time);
  }
  if (typeof time === 'object' && !isnotTrans) {
    time = time.getTime();
  }
  // 判断下时区，如果为其他时区，则先将时间转换为东八区时间, 只转换字符串类型的日期
  // if (
  //   !window.isLocalTimeIsRight &&
  //   !isChinaTimeZone &&
  //   typeof time !== 'string' &&
  //   /^[0-9]+$/.test(time)
  // ) {
  //   time = window.formateTimesStamp(time);
  // }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  let date;
  if (typeof time === 'object') {
    if (!time) {
      return '/';
    }
    date = time;
  } else {
    if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
      time = parseInt(time);
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000;
    }
    if (typeof time === 'string' && /^\d{4}-\d{1,2}-\d{1,2}$/.test(time)) {
      const [y, m, d] = time.split('-').map(Number);
      date = new Date(y, m - 1, d); // 本地“日历日”，不跨时区
    } else {
      date = new Date(time);
    }
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  };
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value];
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value;
    }
    return value || 0;
  });
  return time_str;
}

/**
 * 判断是否为“东八区凌晨房”（00:00 - 05:59）
 * @param {number | string} timestamp - 毫秒级时间戳
 * @returns {boolean}
 */
export function isMorningInCN(timestamp) {
  return momentTimezone
    .tz(Number(timestamp), 'Asia/Shanghai')
    .hour() < 6;
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000;
  } else {
    time = +time;
  }
  const d = new Date(time);
  const now = Date.now();

  const diff = (now - d) / 1000;

  if (diff < 30) {
    return i18n.t('utilsIndex.justNow');
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + i18n.t('utilsIndex.aMinuteAgo');
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + i18n.t('utilsIndex.hoursAgo');
  } else if (diff < 3600 * 24 * 2) {
    return '1天前';
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return (
      d.getMonth() +
      1 +
      i18n.t('utilsIndex.month') +
      d.getDate() +
      i18n.t('common.day') +
      d.getHours() +
      i18n.t('utilsIndex.when') +
      d.getMinutes() +
      i18n.t('common.points2')
    );
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = url.split('?')[1];
  if (!search) {
    return {};
  }
  return JSON.parse(
    '{"' +
    decodeURIComponent(search)
      .replace(/"/g, '\\"')
      .replace(/&/g, '","')
      .replace(/=/g, '":"')
      .replace(/\+/g, ' ') +
    '"}'
  );
}

// 将权限列表更改为树形状态
export function filterArray(jsonData) {
  let objMap = {};
  let treeArr = [];
  jsonData.map((item) => {
    if (objMap[item.parentId]) {
      if (!objMap[item.parentId].children) {
        objMap[item.parentId].children = [];
      }
      objMap[item.id] = item;
      //  判断是否显示，将避免数组的第一个元素是不显示的
      // 否则会出现点击顶部菜单，直接跳转不在菜单显示的页面
      if (item.isShow == 1) objMap[item.parentId].children.unshift(objMap[item.id]);
      else objMap[item.parentId].children.push(objMap[item.id]);
    } else {
      objMap[item.id] = item;
      treeArr.push(objMap[item.id]);
    }
  });
  return treeArr;
}

// 数组递归排序
export function sortArr(arr, compare, child) {
  if (Array.isArray(arr)) {
    arr.sort((a, b) => a[compare] - b[compare]);
    arr.forEach((e) => {
      if (Array.isArray(e[child])) {
        sortArr(e[child], compare, child);
      }
    });
  }
}
// 打开新浏览器窗口
export function openWin(url, id) {
  var a = document.createElement('a');
  a.setAttribute('href', url);
  a.setAttribute('target', 'authLogin');
  a.setAttribute('id', id);
  // 防止反复添加
  if (!document.getElementById(id)) {
    document.body.appendChild(a);
  }
  a.click();
  a.remove();
}
// 获取指定日期的第N天
export function getDate(num = 0, startDate = '', cFormat) {
  if (
    startDate &&
    typeof startDate === 'string' &&
    /^\d{4}.\d{1,2}.\d{1,2}$/.test(startDate.trim())
  ) {
    startDate = `${startDate} 12:00`;
  }
  const now = startDate
    ? typeof startDate !== 'object'
      ? new Date(startDate)
      : startDate
    : new Date(window.formateTimesStamp());
  now.setDate(now.getDate() + num);
  now.setHours(12, 0, 0);
  return cFormat === 'timestamp' ? now.getTime() : parseTime(now, cFormat || '{y}-{m}-{d}', true);
}
// 计算两个日期相差天数
export function DateMinus(start, end) {
  if (typeof start === 'string') {
    start = new Date(start);
  }
  const comeHour = start.getHours();
  start.setHours(12, 0, 0);
  if (typeof end === 'string') {
    end = new Date(end);
  }
  end.setHours(12, 0, 0);
  const num = Math.abs((start.getTime() - end.getTime()) / (24 * 60 * 60 * 1000));
  return Math.floor(num) + (comeHour < 6 ? 1 : 0);
}
// 深复制JSON
export function deepJson(target) {
  const resObj = JSON.parse(JSON.stringify(target));
  return resObj;
}
// 深克隆
export function deepClone(target) {
  if (!target || typeof target !== 'object') {
    return target;
  }
  const resObj = Array.isArray(target) ? [] : {};
  for (const k in target) {
    resObj[k] = deepClone(target[k]);
  }
  return resObj;
}

function parseLocalDate(str) {
  const [y, m, d] = str.split('-').map(Number);
  return new Date(y, m - 1, d);
}
// 获取两个时间差之内的每一天
export function getBetweenDateStr(start, end) {
  // 开始日期和结束日期
  const weekTrans = [
    i18n.t('common.sunday'),
    i18n.t('common.monday'),
    i18n.t('common.tuesday'),
    i18n.t('common.wednesday'),
    i18n.t('common.thursday'),
    i18n.t('common.friday'),
    i18n.t('common.saturday'),
  ];
  const eachDays = eachDayOfInterval({
    start: parseLocalDate(start),
    end: parseLocalDate(end),
  });
  const rangeDays = [];
  eachDays.map((day) => {
    rangeDays.push({
      date: lightFormat(day, 'MM-dd'),
      week: weekTrans[day.getDay()],
    });
  });
  return rangeDays; // 返回两个日期之间的所有日期数组。
}
// 新的防抖函数（————————旧有的防抖函数有问题，但是怕引起旧有的功能出问题————————）
export function rightDebounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result;
  const later = function () {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp;
    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      }
    }
  };

  return function (...newArgs) {
    context = this;
    args = newArgs;
    timestamp = +new Date();
    const callNow = immediate && !timeout;
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, newArgs);
      context = args = null;
    }

    return result;
  };
}

// 防抖函数（—————————————————已废弃，旧有代码在用—————————）
export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result;

  const later = function () {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp;

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      }
    }
  };

  return function (...args) {
    context = this;
    timestamp = +new Date();
    const callNow = immediate && !timeout;
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };
}
// 节流函数
export function throttle(method, delay, duration, timeOutEval = false) {
  var timer = null;
  var begin = new Date();
  return function () {
    var context = this;
    var args = arguments;
    var current = new Date();
    clearTimeout(timer);
    if (timeOutEval && current - begin >= duration) {
      method.apply(context, args);
      begin = current;
    } else {
      timer = setTimeout(function () {
        method.apply(context, args);
      }, delay);
    }
  };
}
/**
 * 下载文件
 * @param { string } downloadUrl
 */
export function downFile(downloadUrl, downloadName = '') {
  // 创建隐藏的可下载链接
  var eleLink = document.createElement('a');
  eleLink.download = downloadName;
  eleLink.style.display = 'none';
  eleLink.href = downloadUrl;
  // 触发点击
  document.body.appendChild(eleLink);
  eleLink.click();
  // 然后移除
  document.body.removeChild(eleLink);
}
// 链接重试
const heartConnect = throttle(initGlobalSocket, 2000);
export function initGlobalSocket() {
  if ('WebSocket' in window) {
    // 打开一个 web socket
    const locale = i18n.locale || i18n.language; // 你的 vue-i18n 当前语言
    const ws = new WebSocket(
      `wss://${config.loginPath
        .replace('https://', '')
        .replace('perm', 'pms')}/pms/system/ws/notice/${store.getters.hotelCode}?token=${getToken(
          'key'
        )}&language=${locale}`
    );

    ws.onopen = () => {
      // Web Socket 已连接上，使用 send() 方法发送数据
      // ws.send('发送数据')
      console.log('全局 websocket已连接...');
    };

    ws.onmessage = (evt) => {
      if (!evt.data.includes(i18n.t('utilsIndex.connectionSuccessful'))) {
        // eslint-disable-next-line no-eval
        const message = JSON.parse(eval(evt.data));
        store.commit('app/SET_SOCKET_MSG', message);
      }
    };

    ws.onclose = () => {
      // 关闭 websocket
      console.log(i18n.t('utilsIndex.theGlobalConnectionIsClosed'));
      heartConnect();
    };
  } else {
    // 浏览器不支持 WebSocket
    console.log(i18n.t('utilsIndex.yourBrowserDoesNotSupportIt'));
    return null;
  }
}

// 解析身份证号信息
export function parseCardNumber(idCard) {
  if (typeof idCard === 'number') {
    idCard += '';
  }
  let birthday = '';
  if (idCard !== null && idCard !== '') {
    if (idCard.length === 15) {
      birthday = '19' + idCard.substr(6, 6);
    } else if (idCard.length === 18) {
      birthday = idCard.substr(6, 8);
    }
    return birthday.replace(/(.{4})(.{2})/, '$1-$2-');
  }
}
// 过滤数字输入
export function clearNoNum(obj, isShowEmpty, isNoPoint) {
  if (typeof obj !== 'object') {
    obj = {
      value: obj,
    };
  }
  // 修复第一个字符是小数点 的情况.
  if (obj.value !== '' && obj.value.substr(0, 1) === '.') {
    obj.value = '';
  }
  if (isNoPoint) {
    obj.value = obj.value.replace(/[^\d]/g, '').toString(); // 清除“数字”以外的字符
  } else {
    obj.value = obj.value.replace(/^0*(0\.|[1-9])/, '$1'); // 解决 粘贴不生效
    obj.value = obj.value.replace(/[^\d.]/g, ''); // 清除“数字”和“.”以外的字符
    obj.value = obj.value.replace(/\.{2,}/g, '.'); // 只保留第一个. 清除多余的
    obj.value = obj.value.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
    obj.value = obj.value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); // 只能输入两个小数
  }
  if (!isShowEmpty && obj.value.indexOf('.') < 0 && obj.value !== '') {
    // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
    if (obj.value.substr(0, 1) === '0' && obj.value.length === 2) {
      obj.value = obj.value.substr(1, obj.value.length);
    }
  }
  return obj.value || (!isShowEmpty ? 0 : '');
}
// 获取当前项目名
export function getHost(url) {
  const startIndex = url.indexOf('//');
  const endIndex = url.indexOf('.');
  if (endIndex < 0) {
    return '';
  }
  return url.substring(startIndex + 2, endIndex);
}
// 过滤证件号码
export function filterCardCode(cardNumber) {
  if (!cardNumber) {
    return '';
  }
  const length = cardNumber.length;
  return cardNumber
    .toString()
    .substring(length - 4, length)
    .padStart(8, '*');
}
/**
 *
 *打印时手机号只显示后四位
 * @param {*} mobile
 * @returns
 */
export function mobileShowFormatter(mobile) {
  if (!mobile) {
    return '--';
  }
  return (mobile + '').substring(7).padStart(11, '*');
}
export function getAssignParams() {
  var args = arguments;
  return Object.assign(...args);
}
// 排房时间处理，精确到秒
export function handleFormateTime(time) {
  if (!time) return '';
  const timeFormatReg = /^\d{4}.\d{2}.\d{2}\s+\d{2}.\d{2}.\d{2}$/;
  return timeFormatReg.test(time) ? time : `${time}:00`;
}

// 查找按钮权限在权限列表里面
export function searchAuthInPermission(auth) {
  if (auth == 'haveThisPermission') {
    return true;
  }
  if (auth)
    return store.getters && store.getters.btnUrlStr && store.getters.btnUrlStr.indexOf(auth) > -1;
  else return false;
}
//去除年月日和时分
export function getTimeBySpilt(time) {
  const targetTime = parseTime(time);
  let res = [];
  targetTime.replace(/(\d{4}-\d{2}-\d{2})\s+(\d{2}:\d{2}:\d{2})/, function (group, str1, str2) {
    res = [str1, str2];
  });
  return res;
}
/**
 *给JSON.parse加上try-catch
 *
 * @export
 * @param {*} targetStr
 * @returns
 */
export function helpJsonParse(targetStr) {
  try {
    return JSON.parse(targetStr || null);
  } catch (error) {
    console.log('JSON.parse异常了', targetStr);
    return null;
  }
}

/**
 * 获取树形数组里面的一个参数
 * @param {string} tree - 树形数组
 * @returns {object} parameterName - 要取的字段名称
 * @returns {string} subarrayName -子数组参数
 */
export function getAllParameterName(tree, parameterName, subarrayName) {
  let arr = [];
  function traverse(node) {
    if (node[parameterName] !== undefined) {
      arr.push(node[parameterName]);
    }
    if (node[subarrayName] && node[subarrayName].length > 0) {
      node[subarrayName].forEach((child) => traverse(child));
    }
  }

  tree.forEach((node) => traverse(node));
  return arr;
}

//返回多语言的className
//@param {string} className
//@returns {string}
export function getClassNameByLanguage(className) {
  let language = store.state.app.language;
  let prefix = language.substr(0, 2);
  return `${className}-${prefix}`;
}


/**
 * base64转blob
 * @param {String} code base64个数数据
 * @return {undefined}
 * @author xxx
 */
function base64ToBlob(code) {
  let parts = code.split(';base64,');
  let contentType = parts[0].split(':')[1];
  let raw = window.atob(parts[1]);
  let rawLength = raw.length;
  let uInt8Array = new Uint8Array(rawLength);
  for (let i = 0; i < rawLength; ++i) {
    uInt8Array[i] = raw.charCodeAt(i);
  }
  return new window.Blob([uInt8Array], { type: contentType });
};

// 下载base64图片
export function downloadBase64(picSrc, imgName) {
  let blob = base64ToBlob(picSrc)  // 转码
  // 'picName.jpeg'
  const filename = imgName
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  document.body.appendChild(a)
  a.href = url
  a.download = filename
  a.click();
  window.URL.revokeObjectURL(url)
  document.body.removeChild(a)
}

/**
 * 解析 URL，获取环境信息
 * @param {string} url - 要解析的 URL
 * @returns {object} - 包含解析后的参数的对象
 */
export const getURLParameters = url => {
  const queryString = url.split('?')[1] || '';
  const pairs = queryString.split('&');

  return pairs.reduce((parameters, pair) => {
    const [key, value] = pair.split('=');
    console.log('value: ', decodeURIComponent(value));
    parameters[decodeURIComponent(key)] = decodeURIComponent(value);
    return parameters;
  }, {});
};
